const http = require('../lib/httpClient');
const { getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COMMERCE_HEADER } = require('../constants');

const catalystConsentTemplateError = {
  code: 'CATALYST_GET_CONSENT_TEMPLATE_TEXT_ERROR',
  message: 'Unable to get consent template',
};

const endpointPattern = '/s/auth/v1/consent/templates?purpose={purpose}';

async function catalystConsentTemplate(purpose, tenantId, catalystBaseUrl = '') {
  const endpoint = endpointPattern.replace('{purpose}', purpose);
  const result = await http.get(`${catalystBaseUrl}${endpoint}`, {
    headers: {
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId),
      'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystConsentTemplateError] };
  const { templates, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  return { data: templates, errors: [] };
}

module.exports = catalystConsentTemplate;
